export const SERVER_URL = "https://api.prophetbots.com";
export const API_URL = SERVER_URL + "/api";

/* Funcs */
export const getMediaUrl = function <T extends { url: string }>(file: T) {
  return SERVER_URL + file.url;
  // return file.url
};
